/** Кнопка закрытия окна или панели с доступным названием действия. */
import { Button } from "./Button";

export const CloseButton = ({
	onClose,
	label = "Закрыть",
}: {
	onClose: () => void;
	label?: string;
}) => (
	<Button
		border={false}
		aria-label={label}
		className="flex size-7 shrink-0 items-center justify-center p-0 text-lg leading-none text-muted hover:text-ink"
		onClick={onClose}
	>
		×
	</Button>
);
